import Vue from 'vue'
import VueRouter from 'vue-router'
import { isUserLoggedIn } from '@/auth/utils'

// Lazy load HomePage for better initial bundle size
const HomePage = () =>
  import(/* webpackChunkName: "homepage" */ '@/views/v3/HomePage.vue')

// Lazy load DashboardPage
const DashboardPage = () =>
  import(/* webpackChunkName: "dashboard" */ '@/views/v3/DashboardPage.vue')

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    // NEW: v3 HomePage as root path
    {
      path: '/',
      name: 'home-v3',
      component: HomePage,
      meta: {
        layout: 'witcher',
        pageTitle: 'Gaming Paradise',
        breadcrumb: [
          {
            text: 'Home v3',
            active: true
          }
        ]
      }
    },

    // Dashboard Page
    {
      path: '/dashboard',
      name: 'dashboard',
      component: DashboardPage,
      meta: {
        layout: 'witcher',
        pageTitle: 'Dashboard',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Dashboard',
            active: true
          }
        ]
      }
    },

    // V3 PAGE ROUTES
    {
      path: '/promotion',
      name: 'promotion-v3',
      component: () => import('@/views/v3/pages/Promotion.vue'),
      meta: {
        layout: 'witcher',
        pageTitle: 'โปรโมชั่น',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'โปรโมชั่น',
            active: true
          }
        ]
      }
    },
    {
      path: '/deposit',
      name: 'deposit-v3',
      component: () => import('@/views/v3/pages/Deposit.vue'),
      meta: {
        layout: 'witcher',
        pageTitle: 'ฝาก',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ฝาก',
            active: true
          }
        ]
      }
    },
    {
      path: '/withdraw',
      name: 'withdraw-v3',
      component: () => import('@/views/v3/pages/Withdraw.vue'),
      meta: {
        layout: 'witcher',
        pageTitle: 'ถอน',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ถอน',
            active: true
          }
        ]
      }
    },
    {
      path: '/cashback',
      name: 'cashback-v3',
      component: () => import('@/views/v3/pages/Cashback.vue'),
      meta: {
        layout: 'witcher',
        pageTitle: 'คืนยอด',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'คืนยอด',
            active: true
          }
        ]
      }
    },
    {
      path: '/checkin',
      name: 'checkin-v3',
      component: () => import('@/views/v3/pages/CheckInPage.vue'),
      meta: {
        layout: 'witcher',
        pageTitle: 'เช็คอินรับโบนัส',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'หน้าแรก',
            to: '/'
          },
          {
            text: 'เช็คอิน',
            active: true
          }
        ]
      }
    },
    {
      path: '/spin-wheel',
      name: 'spin-wheel-v3',
      component: () => import('@/views/v3/pages/SpinWheelPage.vue'),
      meta: {
        layout: 'witcher',
        pageTitle: 'กงล้อมหาโชค',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'กงล้อมหาโชค',
            active: true
          }
        ]
      }
    },
    {
      path: '/coin-exchange',
      name: 'coin-exchange-v3',
      component: () => import('@/views/v3/pages/CoinExchangePage.vue'),
      meta: {
        layout: 'witcher',
        pageTitle: 'แลกเครดิต',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'แลกเครดิต',
            active: true
          }
        ]
      }
    },
    {
      path: '/personal-info',
      name: 'personal-info-v3',
      component: () => import('@/views/v3/pages/PersonalInfo.vue'),
      meta: {
        layout: 'witcher',
        pageTitle: 'ข้อมูลส่วนตัว',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ข้อมูลส่วนตัว',
            active: true
          }
        ]
      }
    },
    {
      path: '/coupon-lotto',
      name: 'coupon-lotto-v3',
      component: () => import('@/views/v3/pages/CouponLotto.vue'),
      meta: {
        layout: 'witcher',
        pageTitle: 'คูปองหวย',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'คูปองหวย',
            active: true
          }
        ]
      }
    },
    {
      path: '/referral',
      name: 'referral-v3',
      component: () => import('@/views/v3/pages/Referral.vue'),
      meta: {
        layout: 'witcher',
        pageTitle: 'ชวนเพื่อน',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ชวนเพื่อน',
            active: true
          }
        ]
      }
    },

    // Start Game - Direct link game launch
    {
      path: '/startgame',
      name: 'startgame',
      component: () => import('@/views/GameplayLoginSlot.vue'),
      meta: {
        layout: 'full'
      }
    },

    // BACKUP ROUTES: All original routes with /backup prefix
    {
      path: '/backup',
      name: 'backup-login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full'
      }
    },
    {
      path: '/backup/register',
      name: 'backup-register',
      component: () => import('@/views/Register.vue'),
      meta: {
        layout: 'full'
      }
    },
    {
      path: '/backup/member/lobby',
      name: 'backup-lobby',
      component: () => import('@/views/Home.vue'),
      meta: {
        breadcrumb: [
          {
            text: 'หน้าแรก',
            active: true
          }
        ]
      }
    },
    {
      path: '/backup/member/deposit',
      name: 'backup-deposit',
      component: () => import('@/views/Deposit.vue'),
      meta: {
        pageTitle: 'ฝาก',
        breadcrumb: [
          {
            text: 'ฝาก'
          }
        ]
      }
    },
    {
      path: '/backup/member/withdraw',
      name: 'backup-withdraw',
      component: () => import('@/views/Withdraw.vue'),
      meta: {
        pageTitle: 'ถอน',
        breadcrumb: [
          {
            text: 'ถอน'
          }
        ]
      }
    },
    {
      path: '/backup/member/setting',
      name: 'backup-setting',
      component: () => import('@/views/Setting.vue'),
      meta: {
        pageTitle: 'ตั้งค่า',
        breadcrumb: [
          {
            text: 'ตั้งค่า'
          }
        ]
      }
    },
    {
      path: '/backup/gameplay',
      name: 'backup-gameplay',
      component: () => import('@/views/Gameplay.vue'),
      meta: {
        layout: 'full'
      }
    },
    {
      path: '/backup/gameplay/casino',
      name: 'backup-casino',
      component: () => import('@/views/GameplayCasino.vue'),
      meta: {
        layout: 'full'
      }
    },
    {
      path: '/backup/gameplay/slot_provider',
      name: 'backup-slot-provider',
      component: () => import('@/views/GameplaySlotProvider.vue'),
      meta: {
        layout: 'full'
      }
    },
    {
      path: '/backup/gameplay/slots',
      name: 'backup-slot',
      component: () => import('@/views/GameplaySlot.vue')
    },
    {
      path: '/backup/gameplay/sport',
      name: 'backup-sport',
      component: () => import('@/views/GameplaySport.vue'),
      meta: {
        layout: 'full'
      }
    },
    {
      path: '/backup/gameplay/login',
      name: 'backup-casinoLogin',
      component: () => import('@/views/GameplayLogin.vue'),
      meta: {
        layout: 'full'
      }
    },
    {
      path: '/backup/gameplay/login/slot',
      name: 'backup-slotLogin',
      component: () => import('@/views/GameplayLoginSlot.vue'),
      meta: {
        layout: 'full'
      }
    },

    // Fallback: redirect to new v3 homepage
    {
      path: '*',
      redirect: '/'
    }
  ]
})

// Navigation guard for authentication (backup safety net)
router.beforeEach((to, _from, next) => {
  // Check if route requires authentication
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Check if user is authenticated
    const userLoggedIn = !!isUserLoggedIn()

    if (!userLoggedIn) {
      // Prevent infinite redirect loops
      if (to.path === '/' && to.query.showLogin) {
        next()
        return
      }

      // This should rarely trigger now since auth is checked at LayoutWitcher level
      console.warn(
        `[Router Guard] Backup auth check triggered for ${to.path} - redirecting to home`
      )

      // Avoid redundant navigation if already at home
      if (to.path === '/') {
        next()
      } else {
        next({
          path: '/',
          query: { showLogin: 'true' }
        })
      }
      return
    }
  }

  next()
})

export default router
